/**
 * @generated SignedSource<<135cab227952667f0f2fa956f2deef8a>>
 * @relayHash c880fb921a6c530f9fd537747b4c7b37
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 444d95b8e718c7484bdbd3853e9b2ae656409de43e3846e73ab5b95f60ecf744

import type { ConcreteRequest } from 'relay-runtime';
export type DeleteInlineCommentInput = {
  commentId: string;
  step?: Step | null | undefined;
};
export type Step = {
  from?: AGG$Long | null | undefined;
  mark: Mark;
  pos?: AGG$Long | null | undefined;
  to?: AGG$Long | null | undefined;
};
export type Mark = {
  attrs?: MarkAttribute | null | undefined;
  type: string;
};
export type MarkAttribute = {
  annotationType: string;
  id: string;
};
export type InlineCommentDeleteInlineCommentMutationWithStepMutation$variables = {
  input: DeleteInlineCommentInput;
};
export type InlineCommentDeleteInlineCommentMutationWithStepMutation$data = {
  readonly deleteInlineComment: boolean | null | undefined;
};
export type InlineCommentDeleteInlineCommentMutationWithStepMutation = {
  response: InlineCommentDeleteInlineCommentMutationWithStepMutation$data;
  variables: InlineCommentDeleteInlineCommentMutationWithStepMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "deleteInlineComment"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "InlineCommentDeleteInlineCommentMutationWithStepMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InlineCommentDeleteInlineCommentMutationWithStepMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c880fb921a6c530f9fd537747b4c7b37",
    "id": "444d95b8e718c7484bdbd3853e9b2ae656409de43e3846e73ab5b95f60ecf744",
    "metadata": {},
    "name": "InlineCommentDeleteInlineCommentMutationWithStepMutation",
    "operationKind": "mutation",
    "text": "mutation InlineCommentDeleteInlineCommentMutationWithStepMutation($input:DeleteInlineCommentInput!){deleteInlineComment(input:$input)}"
  }
};
})();

(node as any).hash = "1aa5c41482c932025b3af698bbf1eaf9";

export default node;
